import React from 'react'
import { TranslateFunction } from '@/utils/translate/translate-client'
import {
  GParagraphLG,
  GParagraphXL,
  GResponsiveText,
} from '@/views/PreSales/PreSalesGiveawayView/components/UI/Typography'

export const getDavidIntroText = (t: TranslateFunction) => (
  <div>
    <GResponsiveText
      color="giveaway-text-subtle-light"
      className="mb-6 pt-3"
      MobileTextComponent={GParagraphLG}
      DesktopTextComponent={GParagraphXL}
    >
      {t(
        'DavidPrizeParagraph1',
        "In a world alive with music, color, and wonder, David follows a young shepherd whose courage and faith set him on an unlikely path to kingship. A surprising triumph places him at the heart of Israel's story, where trials of monumental proportion test his resolve. Through vibrant songs, heartfelt humor, and sweeping adventure, David's unwavering faith guides him toward true greatness—showing that leadership is born not from power, but from trust in God.",
      )}
    </GResponsiveText>
    <GResponsiveText
      color="giveaway-text-subtle-light"
      className="pt-3"
      MobileTextComponent={GParagraphLG}
      DesktopTextComponent={GParagraphXL}
    >
      {t(
        'DavidPrizeParagraph2',
        'In honor of this epic release, Angel Studios is thrilled to unveil the David Christmas Tour',
      )}
    </GResponsiveText>
    <GResponsiveText
      color="giveaway-text-subtle-light"
      className="mb-6"
      MobileTextComponent={GParagraphLG}
      DesktopTextComponent={GParagraphXL}
    >
      {t(
        'DavidPrizeParagraph3',
        'This holiday season, one grand prize family of four will embark on the journey of a lifetime:',
      )}
    </GResponsiveText>
  </div>
)

export const getDavidOutroText = (t: TranslateFunction) => (
  <div>
    <GResponsiveText
      color="giveaway-text-subtle-light"
      className="pt-3"
      MobileTextComponent={GParagraphLG}
      DesktopTextComponent={GParagraphXL}
    >
      {t('DavidPrizeParagraph4', "It's a celebration as bold and unforgettable as David's story itself.")}
    </GResponsiveText>
  </div>
)

export const getDavidPrizeText = (t: TranslateFunction) => (
  <div>
    <ul className="list-disc pl-4">
      <li className="mb-2">
        <GParagraphLG color="giveaway-text-subtle-light">
          {t(
            'holyLandTourText',
            'Walk in the footsteps of King David on a breathtaking trip to the Holy Land with Inspiration Travel',
          )}
        </GParagraphLG>
      </li>
      <li className="mb-2">
        <GParagraphLG color="giveaway-text-subtle-light">
          {t(
            'museumTourText',
            'Experience the Museum of the Bible like never before with a private, after-hours tour in Washington, D.C., exploring David’s lasting impact on Scripture and history.',
          )}
        </GParagraphLG>
      </li>
      <li className="mb-2">
        <GParagraphLG color="giveaway-text-subtle-light">
          {t(
            'homeTheatreText',
            'Bring the story home with an epic home theater system—perfect for watching The Young David series together as a family.',
          )}
        </GParagraphLG>
      </li>
    </ul>
  </div>
)

export const getDavidConfig = () => {
  return {
    grandPrizes: [
      {
        image: 'https://images.angelstudios.com/image/upload/v1760111348/david/Holy_Land_Tour_Ad_v3.webp',
        alt: 'Holy Land Tour',
        title: 'Holy Land Tour',
        value: '$34,000',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1760111348/david/Museum_of_the_Bible_Ad_v3.webp',
        alt: 'Museum of the Bible',
        title: 'Museum of the Bible',
        value: '$10,000',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1760111348/david/Home_Theater_System_Ad_v3.webp',
        alt: 'Home Theater System',
        title: 'Home Theater System',
        value: '$6,000',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1760111350/david/Bitcoin_Cash_Ad_v3.webp',
        alt: 'Bitcoin/Cash',
        title: 'Bitcoin/Cash',
        description: 'Holy Land Tour',
        value: '$10,000',
      },
    ],
    grandPrizeDetails: {
      title: 'David Christmas Tour Giveaway',
      value: '$30,000',
    },
  }
}
